<template>
  <GwMenu
    v-if="asMenu"
    class="unsmenu text-noselect"
    :trigger="trigger"
    :isInside="isInside"
    :ignoreDataGwmenu="ignoreDataGwmenu"
    :flOptions="{ offset: 0, padding: 0 }"
    :placement="placement"
    v-bind="$attrs"
  >
    <template #opener="{ value }">
      <div class="unsmenu_opener">
        <div
          class="gw_btn unsmenu_opener_btn gw_btn_text flex-1"
          style="gap: 0.5rem; --radius: var(--uns-opener-radius)"
          :data-tst="`${tstPrefix}_openbtn`"
          @click.stop="toggleThreeWay"
        >
          <slot
            :name="
              hasNamedSelectedSlot
                ? `selected_${l_activeOption[idKey] || l_activeOption}`
                : 'selected'
            "
            :item="l_activeOption"
          >
            <div
              v-if="openerIcon || (hasIcon && l_activeOption.icon)"
              class="mdi"
              :class="openerIcon || l_activeOption.icon"
            ></div>
            {{
              !hasText ? '' : l_activeOption.text || $t(`${translatePath}.${l_activeOption[idKey]}`)
            }}
          </slot>
        </div>
        <div
          v-if="hasOpener"
          class="mdi text-semi-large icon_btn mdi-menu-down unsmenu_opener_icon ml-auto transition_03"
          :class="{ rotated_180_before: value }"
          :data-tst="`${tstPrefix}_opener`"
          style="transition: 0.22s"
        />
      </div>
    </template>
    <template #default="{ methods }">
      <GwBtns
        :options="l_options"
        :value="l_tab"
        :idKey="idKey"
        :tstPrefix="`${tstPrefix}_btn`"
        class="gwbtns_vertical_primary gw_menu"
        data-gwmenu="noclose"
        @click="
          (e, item) => {
            handleClick(e, item)
            if (closeOnContentClick) {
              methods.toggleOpen(false)
            }
          }
        "
      >
        <template #default="{ item }">
          <slot
            name="item_before"
            :item="item"
          >
          </slot>
          <!-- <slot :item="item"> -->
          <slot
            :name="hasNamedDefaultSlot ? `default_${item[idKey] || item}` : 'default'"
            :item="item"
          >
            <div
              v-if="item.icon"
              class="mdi text-normal mr-2"
              :class="item.icon"
            ></div>
            {{ item.text || $t(`${translatePath}.${item[idKey]}`) }}
          </slot>
          <slot
            name="item_after"
            :item="item"
          >
          </slot>
        </template>
        <template #after>
          <slot
            name="menu_after"
            :methods="methods"
          >
          </slot>
        </template>
      </GwBtns>
    </template>
  </GwMenu>
  <GwBtns
    v-else
    :options="l_options"
    :btnClass="btnClass"
    :value="l_tab"
    :tstPrefix="tstPrefix"
    :idKey="idKey"
    @click="handleClick"
  >
    <!-- style="
      border-radius: 4px;
      background: var(--clr-black-1-3);
      --gwbtn-clr-back: var(--clr-black-1-3);
      --gwbtn-clr-active-white: var(--clr-black-3);
      padding: 0px;
    " -->
    <template #default="{ item }">
      <!-- <slot :item="item"> -->
      <slot
        :name="hasNamedDefaultSlot ? `default_${item[idKey] || item}` : 'default'"
        :item="item"
      >
        <div
          v-if="item.icon"
          class="mdi text-normal mr-2"
          :class="item.icon"
        ></div>
        {{ item.text || $t(`${translatePath}.${item[idKey]}`) }}
      </slot>
    </template>
  </GwBtns>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
// UnSwitcherNew,
import { allSwitchers } from '@/store/switchers/switchers'

export default {
  name: 'UnSwitcherNew',
  components: {
    GwMenu,
    GwBtns,
  },
  props: {
    swKey: { default: '' },
    idKey: { default: 'payload' },
    translatePath: { default: 'switchers' },
    options: Array,
    tab: String,
    btnClass: { default: '' },
    trigger: { default: 'hover' },
    // trigger: { default: 'click' },
    hasIcon: { type: Boolean, default: true },
    hasText: Boolean,
    hasOpener: Boolean,
    // hasOpener: { type: Boolean,  default: true },
    openerIcon: String,
    isInside: Boolean,
    ignoreDataGwmenu: Boolean,
    asMenu: { type: Boolean, default: true },
    closeOnContentClick: Boolean,
    hasToggleThreeWay: { type: Boolean, default: true },
    placement: { default: 'bottom-start' },
    hiddenOptions: Array,

    tstPrefix: { default: 'uns_opener' },

    hasNamedSelectedSlot: Boolean,
    hasNamedDefaultSlot: Boolean,
  },
  emits: ['click:threeway', 'click'],
  data() {
    return {}
  },
  methods: {
    toggleThreeWay(e) {
      this.$emit('click:threeway', this.l_tab)

      if (!this.hasToggleThreeWay) return
      const opts = this.l_options
      const idx = opts.findIndex(i => (i[this.idKey] || i) === this.l_tab)
      const item = opts[idx + 1] || opts[0]
      this.handleClick(e, item)
    },
    handleClick(_e, itemOrId) {
      if (this.tab) {
        this.$emit('click', itemOrId)
        return
      }
      if (this.swKey) {
        this.$store.dispatch('switchers_set_item', {
          key: this.swKey,
          item: itemOrId,
        })
        this.$emit('click', itemOrId)
        return
      }
      this.$emit('click', itemOrId)
    },
  },
  computed: {
    l_tab() {
      return this.tab || this.$store.getters[this.swKey] || this.l_options[0]
    },
    l_options() {
      let res = this.options || allSwitchers()[this.swKey] || []
      if (this.hiddenOptions) {
        res = res.filter(i => !this.hiddenOptions.includes(i[this.idKey]))
      }
      return res
    },
    l_activeOption() {
      const res = this.l_options.find(i =>
        i[this.idKey] ? i[this.idKey] === this.l_tab : i === this.l_tab,
      )
      return res || this.l_options[0]
    },
  },
}
</script>
<style lang="scss" scoped>
.unsmenu {
  --uns-opener-clr-back: transparent;
  --uns-opener-clr: var(--clr-white-0);
  --uns-opener-size: 0.875rem;
  --uns-opener-height: 1.25rem;
  --uns-opener-padding: 0.25rem;
  --uns-opener-radius: 4px;
  &_opener {
    display: flex;
    align-items: center;
    position: relative;
    font-weight: 500;
    height: 100%;
    &_btn {
      --clr-back: var(--uns-opener-clr-back);
      font-size: var(--uns-opener-size);
      padding: var(--uns-opener-padding);
      height: var(--uns-opener-height);
      color: var(--uns-opener-clr);
    }
    &_icon {
      position: absolute;
      right: 0;
      z-index: 1;
    }
  }
}
</style>
